let initialState = {
  appConfig: {
    isMockWrapper: true,
    useMockKambiApi: false,
    useProdApis: false
  },
  appUI: {
    isKambiLoaded: false,
    isMobileLook: false,
    isDebugMode: false,
    nativeUXVersion: null
  },
  breadcrumbs: {
    pageHistory: [],
    isBreadcrumbReady: false
  },
  userContext: {
    offering: '888',
    market: '',
    locale: '',
    kambiSessionId: '',
    isLoggedIn: false,
    isLoginInProgress: false,
    countryISO3: '',
    currency: '',
    langISO2: 'en',
    brand: null,
    subBrand: null,
    streamingAllowedForPlayer: false,
    oddsFormat: 'decimal',
    publicationId: null,
    cid: null,
    globalSessionId: null,
    playerSessionId: null,
    productPackage: null,
    parentProductPackage: null,
    userToken: null
  },
  homePage: {
    keysForStripComponents: [],
    cashoutableBets: []
  },
  kambiWidget: {
    outcomes: [],
    queuedOutcomes: {}
  },
  listView: {
    groupDetails: null,
    eventGroups: [],
    highlightedEvents: []
  },
  externalContent: {
    homePageBanner: {
      content: null,
      isVisible: true //extra conditions that can affect component visibility
    },
    homePageRightBanner: {
      content: null,
      isVisible: true //extra conditions that can affect component visibility
    },
    listView: {
      content: null,
      isVisible: true //extra conditions that can affect component visibility
    }
  },
  liveRightNow: {
    activeSportId: null,
    sportIdsWithEventList: []
  },
  highlightsStrip: {
    activeSportId: null,
    sportIdsWithEventList: [],
    sportGroups: []
  },
  favoritesStrip: {
    initialLoadFailed: false,
    token: null,
    searchResults: [],
    favorites: [],
    settings: {
      comingSoon: false,
      endGame: false
    }
  },
  recommendedForYou: {
    loading: true,
    error: false,
    betRecommendationIds: [],
    loadedEventIds: []
  },
  menu: {
    mappings: null
  }
};

class InitialState {
  static getState() {
    return initialState;
  }

  static setState(state) {
    initialState = state;
  }
}

export default InitialState;
